import styled from 'styled-components';
import { border, layout, padding, margin, color, space, typography } from 'styled-system';
import { GeneralInputStyleProps, defaultInputStyleProps } from './GeneralInputStyles';

export const StyledInput = styled.input<GeneralInputStyleProps>(border, layout, padding, margin, color, space, typography, (props) => ({
  lineHeight: 'inherit',
  ':read-only': {
    backgroundColor: props.theme.colors.secondary[0],
  },
  '::placeholder': {
    color: props.theme.colors.placeholder,
    opacity: 1,
  },
  outline: props.outline,
}));

StyledInput.defaultProps = {
  ...defaultInputStyleProps,
};
